// extracted by mini-css-extract-plugin
module.exports = {"container":"auth_container__QcPr_","background":"auth_background__SQUnn","modalContent":"auth_modalContent__65zZy","logo":"auth_logo__ZjSPe"};